import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams } from 'ionic-angular'

import { AuthProvider } from '../../providers/auth/auth'

import * as d3 from 'd3-selection'
import * as d3Scale from "d3-scale"
import * as d3Shape from "d3-shape"
import { DeviceType } from '../../models/models'
import { DeviceProvider } from '../../providers/device/device'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-heating-consumption',
	templateUrl: 'heating-consumption.html',
})
export class HeatingConsumptionPage {
	previousRooms: any = [];
	previousTotal = 0;
	previousRelative = 0;

	rooms: any = [];
	total = 0;
	relative = 0;

	period: string = 'yesterday';
	periodName = '';
	previousPeriodName = '';

	isComparing: boolean

	/*
		Impostazioni grafici
	*/
	margin = { top: 0, right: 100, bottom: 50, left: 100 };
	/*
	width: number;
	height: number;
	radius: number;

	arc: any;
	labelArc: any;
	pie: any;
	color: any;
	svg: any;
	*/

	constructor(
		private auth: AuthProvider,
		private devices: DeviceProvider,
		private navCtrl: NavController,
		private navParams: NavParams
	) {}

	ionViewDidEnter() {
		this.update()
	}
	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}

	update() {
		let numbers = 81689939
		let max = 1999//N° primo per generare numeri meglio distribuiti
		let rooms = [
			'cucina',
			'bagno 1',
			'bagno 2',
			'camera 1',
			'camera 2',
			'camera 3',
			'ingresso',
			'dispensa'
		]

		let days = 150

		switch(this.period) {
			case 'yesterday':
				this.periodName = 'Ieri'
				days /= 150
				break
			case 'week':
				this.periodName = 'Questa settimana'
				days /= 21
				this.previousPeriodName = 'La settimana scorsa'
				break
			case 'month':
				this.periodName = 'Questo mese'
				days /= 5
				this.previousPeriodName = 'Il mese scorso'
				break
			case 'winter':
				this.periodName = 'Questo inverno'
				this.previousPeriodName = 'L\'inverno scorso'
				break
		}

		this.relative = 0.48

		for(let i = 0; i < rooms.length; i++) {
			this.rooms[i] = {
				name: rooms[i],
				number: numbers++,
				read: (1009 * (numbers + 101) * 150 / days) % max,
			}
			this.total += this.rooms[i].read
		}
		for(let i = 0; i < rooms.length; i++) {
			this.rooms[i].relative = this.rooms[i].read / this.total
		}

		this.previousRelative = 0.56
		for(let i = 0; i < rooms.length; i++) {
			this.previousRooms[i] = {
				name: rooms[i],
				number: this.rooms[i].number,
				read: (1009 * numbers++ * 150 / days) % max,
			}
			this.previousTotal += this.previousRooms[i].read
		}
		for(let i = 0; i < this.previousRooms.length; i++) {
			this.previousRooms[i].relative = this.previousRooms[i].read / this.total
		}




		this.draw('chart', this.rooms)
		this.draw('previous-chart', this.previousRooms)
		//this.drawChart();
	}

	draw(id, data) {
		let element = document.getElementById(id)
		if(!element) return//Elemento non ancora inizializzato

		element.innerHTML = ''//Svuota il grafico precedente

		let w = document.getElementById(id).offsetWidth//.clientWidth;
		let h = document.getElementById(id).offsetHeight
		//console.log('w='+w);


		//Init grafici
		let width = w - this.margin.left - this.margin.right
		let height = h - this.margin.top - this.margin.bottom
		let radius = Math.min(width, height) / 2

		let svg = d3.select('#' + id).append('svg')
		svg.attr("width", '100%').attr("height", h + 'px').attr('viewBox', '0 0 ' + Math.min(width, height) + ' ' + Math.min(width, height))

		let g = svg.append("g")
		g.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")

		let colors = d3Scale.scaleOrdinal(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00", "#7bd03c"])


		let pie = d3Shape.pie().sort(null).value((room: any) => room.read)

		let path = d3Shape.arc().outerRadius(radius - Math.max(this.margin.top, this.margin.bottom) - 50).innerRadius(0).padAngle(0.03).cornerRadius(8)

		let label = d3Shape.arc().outerRadius(radius - Math.max(this.margin.top, this.margin.bottom)).innerRadius(radius - Math.max(this.margin.top, this.margin.bottom) - 25)

		let arc = g.selectAll(".arc").data(pie(data)).enter().append("g").attr("class", "arc")

		arc.append("path").attr("d", <any>path).attr("fill", function(d) { return colors((<any>d).data.number) })
		arc.append("text").attr("transform", function(d) { return "translate(" + label.centroid(<any>d) + ")" }).attr("dy", "0.5em").attr("dx", "-25px").text(function(d) { return (<any>d).data.name })
	}


	ionViewWillUnload() {
		//se il contesto lo richiede esegue il logout in uscita
		switch(this.devices.actualType) {
			case DeviceType.DASHBOARD:
			case DeviceType.INTERCOM:
				if(this.auth.user) {
					this.auth.logout()
				}
				break
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/heating-consumption/heating-consumption.ts